import React from 'react'
import { Link } from 'react-router-dom'
import CarouselShow from '../carousel/CarouselShow'
import CategoriesCards from '../categoriesCards/CategoriesCards'

const HomeShow = () => {
    return (
        <div className='container'>
            <div className='row mt-3'>
                <div className='text-center'>
                    <Link className="btn btn-light" to="/MainShow"><i className="fa fa-search" /></Link>
                </div>
            </div>
            <div className='row mt-3'>
                <div className='col col-12 mb-3'>
                    <CarouselShow />
                </div>
                <div className='col col-12 mb-3'>
                    <CategoriesCards />
                </div>
            </div>
            {/* <div className='mt-3' style={{width: "100%", borderTop:'1px solid black'}}>
                <AboutUs></AboutUs>
            </div> */}
        </div>
    )
}

export default HomeShow